module.exports = __webpack_public_path__ + "static/img/weizhang.8b0920c0.png";